/**
 * Отказы бэкенда, которые узнаются **по тексту**, а не по коду, — раздел «по тексту» реестра
 * (`BACKEND_ERROR_TEXT_RULES` в `backend-error-messages.ts`).
 *
 * Причин две, и обе — долг бэкенда (задача на свой код у каждого случая, IMGM-1562):
 * - у отказа **нет кода**: голый `Exception` в `CommandHandler::gqlHandle`, валидатор Symfony, REST
 *   ссылки на заявку (`ExceptionListener` отдаёт только HTTP-статус);
 * - **один код — несколько причин** (`8005 STAGE_INVALID` у генерации матчей, `18025
 *   BILLING_PAYMENT_FAILED`): различает только текст.
 *
 * Значение — стабильный идентификатор случая, как код: по нему фича ветвится
 * (`getBackendErrorText(error) === BackendErrorText.LINK_TOKEN_EXPIRED`) и его же задают в
 * `overrides`. Строковый enum — ключи `overrides` не пересекаются с числовыми кодами.
 */
export enum BackendErrorText {
  // 8005 STAGE_INVALID — генерация матчей (`GenerateStageMatchesHandler.php`)
  STAGE_TYPE_NOT_SUPPORTED = 'STAGE_TYPE_NOT_SUPPORTED',
  STAGE_HAS_NO_TEAM_GROUPS = 'STAGE_HAS_NO_TEAM_GROUPS',
  GROUP_NOT_ENOUGH_TEAMS = 'GROUP_NOT_ENOUGH_TEAMS',
  STAGE_NOT_ENOUGH_TEAMS = 'STAGE_NOT_ENOUGH_TEAMS',

  // 18025 BILLING_PAYMENT_FAILED — пополнение кошелька (`TBankLimits.php`)
  CARD_PAYMENTS_DISABLED = 'CARD_PAYMENTS_DISABLED',

  // без кода
  /** `ApplicationLimitExceededException`: объявленный `7015` бэкенд не присылает. */
  APPLICATION_LIMIT_EXCEEDED = 'APPLICATION_LIMIT_EXCEEDED',
  /** `ChargeWalletHandler.php` — голый `Exception`. */
  NOT_ENOUGH_MONEY = 'NOT_ENOUGH_MONEY',
  /** Валидатор `CreateWalletTopupCommand` на поле `email`. */
  RECEIPT_EMAIL_INVALID = 'RECEIPT_EMAIL_INVALID',
  /** Валидатор `UniqueValueInEntity` — значение поля уже занято. */
  VALUE_ALREADY_USED = 'VALUE_ALREADY_USED',

  // REST ссылки на заявку (`ChampionshipApplicationsController.php`)
  LINK_TOKEN_MISSING = 'LINK_TOKEN_MISSING',
  LINK_TOKEN_EXPIRED = 'LINK_TOKEN_EXPIRED',
  LINK_TOKEN_INVALID = 'LINK_TOKEN_INVALID',
  LINK_FIELD_NUMBER = 'LINK_FIELD_NUMBER',
  LINK_FIELD_POSITION = 'LINK_FIELD_POSITION',
  LINK_FIELD_NAME = 'LINK_FIELD_NAME',
  LINK_FIELD_SURNAME = 'LINK_FIELD_SURNAME',
  LINK_FIELD_BIRTH_DATE = 'LINK_FIELD_BIRTH_DATE',
  LINK_BIRTH_DATE_FORMAT = 'LINK_BIRTH_DATE_FORMAT',
  LINK_PHOTO_TYPE_NOT_ALLOWED = 'LINK_PHOTO_TYPE_NOT_ALLOWED',
  /** Фото не загрузилось **после** создания заявки: заявка есть, потеряно только фото. */
  LINK_PHOTO_UPLOAD_FAILED = 'LINK_PHOTO_UPLOAD_FAILED',
  LINK_TEAM_NOT_IN_CHAMPIONSHIP = 'LINK_TEAM_NOT_IN_CHAMPIONSHIP',
  LINK_CHAMPIONSHIP_NOT_FOUND = 'LINK_CHAMPIONSHIP_NOT_FOUND',
  LINK_TEAM_NOT_FOUND = 'LINK_TEAM_NOT_FOUND',
}

/**
 * Где разбирается ошибка. Правило с контекстом проверяется, только если место вызова его назвало:
 * общие фразы вроде «email» или «This value is already used.» в чужом ответе дали бы ложный перевод.
 */
export enum BackendErrorContext {
  /** Пополнение кошелька и покупка тарифа. */
  WALLET = 'WALLET',
  /** Публичная страница заявки по ссылке (REST). */
  APPLICATION_LINK = 'APPLICATION_LINK',
  /** Поле «Телефон» формы регистрации. */
  SIGN_UP_PHONE = 'SIGN_UP_PHONE',
}
